export class StringUtils {
  static stringToDom(str) {
    const div = document.createElement('div');
    div.innerHTML = str;
    return div.firstChild;
  }

  /**
   * 入力文字を式かどうか評価する
   * @param  inputText
   */
  static isStatementInput(inputText) {
    return inputText.startsWith('=');
  }

  /**
   * 入力文字を式かどうか評価する
   * @param  inputText
   */
  static trimFirstEqualChar(inputText) {
    return inputText.replace('=', ''); // replace は初めの１文字だけ入れ替える。
  }

  /**
   * 半角文字に変換
   * @param {*} strNum
   */
  static toSingleByteNumber(strNum) {
    let result = strNum.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
      return String.fromCharCode(s.charCodeAt(0) - 65248);
    });
    result = result.replace('\u2012', '-'); // FIGURE DASH（ダッシュ記号）
    result = result.replace('\u2013', '-'); // EN DASH（短いダッシュ記号）
    result = result.replace('\u2014', '-'); // EM DASH（長いダッシュ記号）
    result = result.replace('\u2015', '-'); // HORIZONTAL BAR（横棒）
    result = result.replace('\u2212', '-'); // MINUS SIGN（マイナス記号）
    result = result.replace('\uFF0D', '-'); // FULLWIDTH HYPHEN-MINUS（ハイフンマイナス記号）
    return result;
  }

  static formatXml(xml: string) {
    let formatted = '';
    const reg = /(>)(<)(\/*)/g;
    xml = xml.replace(reg, '$1\r\n$2$3');
    let pad = 0;
    xml.split('\r\n').forEach(function (node) {
      let indent = 0;
      if (node.match(/.+<\/\w[^>]*>$/)) {
        indent = 0;
      } else if (node.match(/^<\/\w/)) {
        if (pad != 0) {
          pad -= 1;
        }
      } else if (node.match(/^<\w[^>]*[^/]>.*$/)) {
        indent = 1;
      } else {
        indent = 0;
      }

      let padding = '';
      for (let i = 0; i < pad; i++) {
        padding += '  ';
      }

      formatted += padding + node + '\r\n';
      pad += indent;
    });

    return formatted;
  }

  /**
   * HTMLエンコードした文字かえす
   * @param  {[type]} value [description]
   * @return {[type]}       [description]
   */
  static htmlEncode(naturalHtmlString: string) {
    return naturalHtmlString
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /**
   * HTMLエンコードされた文字列をデコードする
   */
  static htmlDecode(sanitizedString: string) {
    return sanitizedString
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
}
